import {IconProps} from '../icon-props-interface';
import '../icons.scss';

const IconCircleLeft = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 9C18 13.9711 13.9711 18 9 18C4.02891 18 0 13.9711 0 9C0 4.02891 4.02891 0 9 0C13.9711 0 18 4.02891 18 9ZM9.52734 13.2539C9.85781 13.5844 10.3922 13.5844 10.7191 13.2539C11.0461 12.9234 11.0496 12.3891 10.7191 12.0621L7.66055 9.00352L10.7191 5.94492C11.0496 5.61445 11.0496 5.08008 10.7191 4.75312C10.3887 4.42617 9.8543 4.42266 9.52734 4.75312L5.87109 8.40234C5.54062 8.73281 5.54062 9.26719 5.87109 9.59414L9.52734 13.2539Z"
      fill={color}/>
</svg>

    </div>
);

export default IconCircleLeft;
